import { render } from "./ForgotScreen.vue?vue&type=template&id=db3bee2e"
import script from "./ForgotScreen.vue?vue&type=script&lang=js"
export * from "./ForgotScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__